import { HashtagIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import Link from 'next/link';

const pill = (size, uid) => {
  return (
    <p
      className={clsx(
        `inline-flex  rounded-md bg-teal-100 px-2 text-${size} font-semibold leading-5 text-teal-800`
      )}
    >
      <HashtagIcon
        className={clsx(
          size === 'xs' ? 'h-4 w-4' : 'h-7 w-7',
          'my-auto ml-1.5 flex-shrink-0 text-teal-400'
        )}
        aria-hidden="true"
      />
      <span className=" my-auto">Kod: {uid}</span>
    </p>
  );
};

export default function UidCodeButton({ uid, size = 'xs', disable = false }) {
  return disable ? (
    pill(size, uid)
  ) : (
    <Link className="hover:underline" href={{ pathname: `/bookle/${uid}` }}>
      {pill(size, uid)}
    </Link>
  );
}
